import { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import api from "../../../services/api";
import Template from "../../../template";
import { toast } from "react-toastify";
import { useCorrecao } from "../../../context/correcao";

import * as S from "./styled";

function UploadRedacaoTeste() {
  const history = useHistory();
  const { saveCorrecaoCompleta, clearCorrecaoData } = useCorrecao();
  
  const fileInputRef = useRef(null);
  const isMountedRef = useRef(true);
  const [arquivo, setArquivo] = useState("");
  const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
  const [previewImagem, setPreviewImagem] = useState(null);
  const [temaTexto, setTemaTexto] = useState(""); // Campo livre para o usuário digitar
  const [loading, setLoading] = useState(false);

  // Cleanup para evitar memory leak
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Função para gerar preview da imagem
  const generatePreview = async (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (isMountedRef.current) {
          setPreviewImagem(e.target.result);
        }
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error('Erro ao gerar preview:', error);
      if (isMountedRef.current) {
        setPreviewImagem(null);
      }
    }
  };

  async function sendFileIA(file) {
    console.log('sendFileIA iniciada (teste):', { file: file?.name, temaTexto });
    
    if (!temaTexto.trim()) {
      toast.error("Por favor, digite o tema da redação");
      return;
    }

    if (!file) {
      toast.error("Por favor, selecione uma imagem");
      return;
    }

    setLoading(true);
    
    try {
      console.log('Preparando imagem para envio...');
      
      // Converter arquivo para data URL para salvar no contexto
      const imageDataURL = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
      
      const data = new FormData();
      data.append("file", file);
      data.append("theme", temaTexto);

      console.log('FormData preparado, enviando para /redacao/ia/teste...');
      console.log('Dados enviados:', { theme: temaTexto });

      const retorno = await api.post("/redacao/ia/teste", data);
      
      console.log('Resposta completa recebida:', retorno);
      console.log('Dados da resposta:', retorno.data);
      
      toast.success("Redação enviada para correção IA com sucesso!");
      
      // O endpoint de teste retorna diretamente os dados da correção
      if (retorno.data) {
        // Salvar os dados no contexto
        const dadosCorrecao = {
          correcao: retorno.data,
          imagem: imageDataURL,
          arquivo: arquivoSelecionado,
          tema: temaTexto
        };
        
        saveCorrecaoCompleta(dadosCorrecao);
        
        console.log('Dados da correção salvos no contexto');
        console.log('Redirecionando para página de correção de teste');
        
        // Redirecionar para a página de correção de teste
        history.push('/correcao-teste/resultado');
      } else {
        console.log('Nenhum dado retornado na resposta');
        toast.error("Erro: Nenhum dado de correção retornado.");
      }
      
    } catch (error) {
      console.error('Erro detalhado ao enviar redação:', error);
      console.error('Error response:', error.response);
      console.error('Error message:', error.message);
      
      if (error.response?.data?.message) {
        toast.error(`Erro: ${error.response.data.message}`);
      } else {
        toast.error("Erro ao processar e enviar redação para correção");
      }
    } finally {
      // Só atualizar o estado se o componente ainda estiver montado
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  }

  const handleEnviarRedacao = () => {
    sendFileIA(arquivoSelecionado);
  };

  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    
    if (!file) {
      return;
    }
    
    // Verificar se é uma imagem (JPG ou PNG)
    if (!file.type.match(/^image\/(jpeg|jpg|png)$/)) {
      toast.error("Por favor, envie apenas arquivos JPG ou PNG.");
      event.target.value = ''; // Limpar o input
      return;
    }

    // Verificar tamanho do arquivo (máximo 10MB)
    if (file.size > 10 * 1024 * 1024) {
      toast.error("Arquivo muito grande. Máximo 10MB.");
      event.target.value = ''; // Limpar o input
      return;
    }

    // Armazenar o arquivo selecionado apenas se o componente ainda estiver montado
    if (isMountedRef.current) {
      setArquivo(file.name);
      setArquivoSelecionado(file);
      
      // Gerar preview da imagem
      await generatePreview(file);
      
      toast.success(`Arquivo "${file.name}" selecionado com sucesso!`);
    }
  };

  const handleClickUpload = () => {
    fileInputRef.current?.click();
  };

  return (
    <Template>
      <S.MainWrapper>
        <Container>
          <Row>
            <Col sm={12}>
              <S.MainContent>
                <Row>
                  <Col>
                    <legend>
                      <strong>Teste - Enviar redação para correção por I.A.</strong>
                    </legend>
                    <p className="text-muted">
                      Envie sua redação em imagem (JPG ou PNG) para teste da correção por Inteligência Artificial.
                    </p>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Tema da Redação *</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Digite o tema da sua redação"
                        value={temaTexto}
                        onChange={(e) => setTemaTexto(e.target.value)}
                        maxLength={200}
                      />
                      <Form.Text className="text-muted">
                        Digite livremente o tema da sua redação (máximo 200 caracteres).
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    {/* Input file oculto */}
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      onChange={handleFileSelect}
                      style={{ display: 'none' }}
                    />
                    
                    {/* Área de seleção de arquivo */}
                    <div 
                      style={{
                        border: '2px dashed #007bff',
                        borderRadius: '8px',
                        padding: '40px 20px',
                        textAlign: 'center',
                        backgroundColor: '#f8f9fa',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease'
                      }}
                      onClick={handleClickUpload}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#e9ecef';
                        e.target.style.borderColor = '#0056b3';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#f8f9fa';
                        e.target.style.borderColor = '#007bff';
                      }}
                    >
                      <div>
                        <p><strong>🖼️ Clique aqui para selecionar sua imagem</strong></p>
                        <p className="text-muted" style={{backgroundColor:'rgba(233, 236, 239, 0)'}}>Apenas JPG ou PNG • Máximo 10MB</p>
                        {arquivo && (
                          <p className="text-success">
                            <small>✅ Arquivo selecionado: {arquivo}</small>
                          </p>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                {previewImagem && (
                  <Row>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>Preview da Redação</Form.Label>
                        <div className="text-center">
                          <img 
                            src={previewImagem} 
                            alt="Preview da redação" 
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: '1000px', 
                              border: '1px solid #ddd',
                              borderRadius: '8px',
                              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                            }} 
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col>
                    <div className="d-grid gap-2 mt-4 mb-4 text-center">
                      <Button 
                        variant="primary" 
                        size="lg" 
                        onClick={handleEnviarRedacao}
                        disabled={loading || !arquivoSelecionado || !temaTexto.trim()}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            <span style={{ marginLeft: "10px" }}>
                              Nossa I.A. está corrigindo sua redação, aguarde...
                            </span>
                          </>
                        ) : (
                          "Enviar para Correção IA"
                        )}
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col>
                    <div className="alert alert-warning">
                      <h6>Informações importantes:</h6>
                      <ul className="mb-0">
                        <li>Esta é uma versão de teste da correção por IA</li>
                        <li>A redação não será salva no sistema</li>
                        <li>Você pode enviar apenas 1 redação para teste</li>
                        <li>O resultado será exibido imediatamente após o processamento</li>
                        <li>Se você sair da tela da correção já realizada, não poderá acessá-la novamente</li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </S.MainContent>
            </Col>
          </Row>
        </Container>
      </S.MainWrapper>
    </Template>
  );
}

export default UploadRedacaoTeste;